/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Parq_QuestionInputs */

const en_us2_onboarding_parq_question = /** @type {(inputs: Onboarding_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick health check: tap anything that is true for you, then confirm.`)
};

const pt_br2_onboarding_parq_question = /** @type {(inputs: Onboarding_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checagem rápida de saúde: toque no que for verdade para você e confirme.`)
};

const es_419_onboarding_parq_question = /** @type {(inputs: Onboarding_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión rápida de salud: toca lo que sea cierto para ti y confirma.`)
};

const pt_pt2_onboarding_parq_question = /** @type {(inputs: Onboarding_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificação rápida de saúde: toca no que for verdade para ti e confirma.`)
};

const fr_fr2_onboarding_parq_question = /** @type {(inputs: Onboarding_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petit bilan de santé : touche ce qui est vrai pour toi, puis confirme.`)
};

const de_de2_onboarding_parq_question = /** @type {(inputs: Onboarding_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzer Gesundheitscheck: Tippe an, was auf dich zutrifft, und bestätige dann.`)
};

const it_it2_onboarding_parq_question = /** @type {(inputs: Onboarding_Parq_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo rapido della salute: tocca ciò che vale per te, poi conferma.`)
};

/**
* | output |
* | --- |
* | "Quick health check: tap anything that is true for you, then confirm." |
*
* @param {Onboarding_Parq_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_parq_question = /** @type {((inputs?: Onboarding_Parq_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Parq_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_parq_question(inputs)
	if (locale === "es-419") return es_419_onboarding_parq_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_parq_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_parq_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_parq_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_parq_question(inputs)
	return en_us2_onboarding_parq_question(inputs)
});
export { onboarding_parq_question as "onboarding.parq.question" }